/**
 * 화면 소스 파일이 번들에 있는가 — MainLayout 이 메뉴를 열 때 파일을 찾는 규칙과 같다 (2026-09-30).
 *
 * 메뉴디자이너 배포가 "패키지 메뉴(소스로 만든 화면)" 를 가르는 데 쓴다.
 * 노츠메뉴에 등록하면 화면 파일 칸(nm_file)이 메뉴코드로 자동으로 채워지므로 그 칸으로는 못 가른다 —
 * 실제 소스 파일이 있어야 패키지 메뉴다. 공용 페이지(SN_COM_LAYOUT)는 사용자 정의 메뉴의 파일이라 패키지가 아니다.
 */
/* MainLayout 과 같은 선언 — CRA 의 require.context 는 타입이 없다 */
declare const require: {
  context(path: string, deep?: boolean, filter?: RegExp): { keys: () => string[] };
};

const modules = require.context("@menu", true, /\.tsx$/);

export const COMMON_LAYOUT_FILE = "SN_COM_LAYOUT";

/** nm_file 로 소스 화면을 찾는다 — 정확한 경로, 없으면 폴더/이름/이름.tsx */
export function hasScreenModule(filePath: string | null | undefined): boolean {
  const f = (filePath || "").trim();
  if (!f || f.toUpperCase() === COMMON_LAYOUT_FILE) return false;
  const keys = modules.keys();
  if (keys.some((key) => key.endsWith(`${f}.tsx`))) return true;
  const name = f.split("/").pop();
  return !!name && keys.some((key) => key.endsWith(`/${name}/${name}.tsx`));
}
